type CacheEntry<T> = { value: T; ts: number };

const memory = new Map<string, CacheEntry<unknown>>();

export function getCache<T>(key: string, ttlMs: number): T | null {
  const now = Date.now();
  const mem = memory.get(key);
  if (mem && now - mem.ts <= ttlMs) return mem.value as T;

  try {
    const raw = window.localStorage.getItem(`boxbet:${key}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as CacheEntry<T>;
    if (now - parsed.ts > ttlMs) return null;
    memory.set(key, parsed as CacheEntry<unknown>);
    return parsed.value;
  } catch {
    return null;
  }
}

export function setCache<T>(key: string, value: T): void {
  const entry: CacheEntry<T> = { value, ts: Date.now() };
  memory.set(key, entry as CacheEntry<unknown>);
  try {
    window.localStorage.setItem(`boxbet:${key}`, JSON.stringify(entry));
  } catch {
    // best effort
  }
}
